const s = {
  name: "Library",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M32,34H22v2h10V34z"/>
		<path class="st0" d="M4,36V26h2v10H4z"/>
		<path class="st0" d="M20,0H8v12H0v28h40V24h-6v-8H20V0z M20,18h12v6H20V18z M20,26h2v4h-2V26z M24,26h10v4H24V26z M38,30h-2v-4h2
			V30z M20,32h18v6H20V32z M18,4h-8V2h8V4z M18,6v28h-8V6H18z M10,36h8v2h-8V36z M8,38H2V14h6V38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Library
};
